module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/hero-6aec492b91bad39e596dc6f3b4ddf3b6.jpg";